import React, { memo } from 'react';
import formStyles from '../../../form/Form.module.css';

/* Seções */
import ImovelSection from '../sections/ImovelSection';
import VtrSection from '../sections/VtrSection';
import InventarioSection from '../sections/InventarioSection';
import PocoSection from '../sections/PocoSection';

/* Componentes UI Padrão */
import Select from '../../../form/Select';
import Input from '../../../form/Input';
import Checkbox from '../../../form/Checkbox';
import DataList from '../../../form/DataList';

const BensTabPanel = ({ module, dados, setFlashMessage, profile, theme, mrt }) => {
    const { state, actions } = module;
    const { uiTabs } = profile;

    const bem = dados?.produtoBens || {};
    const showBens = uiTabs?.bens?.show || {};
    const labelsBens = uiTabs?.bens?.labels || {};

    const tipo = bem.tipo || 'Bem';
    const isPoco = [true, 1, '1', 'true'].includes(bem.isPoco);

    // regra simples e previsível
    const podeTerMobilia = tipo === 'Imóvel'; // ajuste se quiser permitir em outros
    const showMobilia = podeTerMobilia && !!bem.mobiliado;

    return (
        <div className={formStyles.stiloPadrao}>
            <div className={formStyles.preview_bandeira}>
                <h4>{labelsBens?.form}</h4>
            </div>

            <div className={formStyles.row}>
                <Input
                    text="Patrimônio"
                    name="produtoBens.patrimonio"
                    placeholder="Nº Patrimônio"
                    handleOnChange={actions.draft.change}
                    value={bem.patrimonio || ''}
                    inputWidth="150px"
                />

                <Input
                    text="Descrição do BEM"
                    name="produtoBens.descricao"
                    placeholder="Descrição detalhada"
                    inputWidth="350px"
                    handleOnChange={actions.draft.change}
                    handleOnFocus={actions.draft.handlePBDescricaoFocus}
                    value={bem.descricao || ''}
                />

                <Select
                    name="produtoBens.tipo"
                    text="Tipo"
                    options={state.EnumBemTipo}
                    handleOnChange={actions.draft.change}
                    value={tipo}
                    isEnum={true}
                />

                <Checkbox text="Ativo" name="produtoBens.ativo" handleOnChange={actions.draft.change} checked={!!bem.ativo} />
            </div>

            <div className={formStyles.row}>
                <DataList
                    text="Proprietário"
                    name="Proprietario.descricao"
                    placeholder="Localizar proprietário/locador"
                    inputWidth="400px"
                    filteredOptions={state.OptionsProprietario}
                    handleOnChange={actions.draft.change}
                    value={state.Proprietario?.descricao || ''}
                />

                {showBens?.mobiliado && (
                    <Checkbox
                        text="Possui Mobília/Inventário"
                        name="produtoBens.mobiliado"
                        handleOnChange={actions.draft.change}
                        checked={!!bem.mobiliado}
                        // disabled={!podeTerMobilia} // evita marcar “mobília” em VTR, se você quiser
                    />
                )}
                {showBens?.poco && (
                    <Checkbox text="Poço" name="produtoBens.isPoco" handleOnChange={actions.draft.change} checked={isPoco} />
                )}
            </div>

            {showBens?.imovel && <ImovelSection bem={bem} actions={actions} state={state} setFlashMessage={setFlashMessage} />}

            {showBens?.veiculo && <VtrSection bem={bem} actions={actions} state={state} setFlashMessage={setFlashMessage} />}

            {isPoco && <PocoSection bem={bem} actions={actions} />}

            {showMobilia && (
                <InventarioSection module={module} dados={dados} theme={theme} mrt={mrt} setFlashMessage={setFlashMessage} />
            )}
        </div>
    );
};

export default memo(BensTabPanel);
